import * as Yup from 'yup';

export const getExtendSeatSchema = () => {
    return Yup.object().shape({
        seatCount: Yup.number()
            .typeError('Seat count must be a number')
            .required('Seat count is required')
            .positive('Seat count must be a positive number')
            .integer('Seat count must be a whole number'),
        amount: Yup.string()
            .nullable()
            .notRequired(),
    });
};